function ArrowDisabler(Glide, Components) {
    return {
        mount() {
            if (Glide.settings.rewind) {
                return
            }

            Glide.on(['mount.after', 'run'], () => {
                Components.Controls.items.forEach((controlItem) => {
                    if (!controlItem.classList.contains('glide__arrows')) {
                        return
                    }

                    const left = controlItem.querySelector('.glide__arrow--prev')
                    const right = controlItem.querySelector('.glide__arrow--next')

                    if (left) {
                        if (Glide.index === 0) {
                            left.setAttribute('disabled', '') // Disable on first slide
                        } else {
                            left.removeAttribute('disabled') // Enable on other slides
                        }
                    }

                    if (right) {
                        if (Glide.index === Components.Sizes.length - Glide.settings.perView) {
                            right.setAttribute('disabled', '') // Disable on first slide
                        } else {
                            right.removeAttribute('disabled') // Enable on other slides
                        }
                    }
                })
            })
        },
    }
}

export default ArrowDisabler
